import React, { Component, Suspense } from 'react';
import { Spinner } from '@chargepoint/cp-kit/spinner';
import Router from './Router';
import Auth from './Router/Auth';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInitialized: false
    };
  }

  componentDidMount() {
    Auth.isSSOEnabled()
      .then(() =>
        Auth.validateSession()
          .then(response => {
            const ct = response.headers.get('content-type');
            if (!ct || !ct.includes('application/json'))
              throw new Error('Not JSON');
            if (!response.ok) throw response.statusText;
            return response.json();
          })
          .then(result => {
            if (result.is_user_valid) {
              Auth.autoSignin(result.full_name);
            } else {
              if (result.error) Auth.errorMessage = result.message;
              throw new Error('User or Password is invalid');
            }
          })
          .catch(() => {
            Auth.signout();
          })
          .finally(() => {
            this.setState({ isInitialized: true });
          })
      )
      .catch(() => {
        this.setState({ isInitialized: true });
      });
  }

  render() {
    return (
      <Suspense fallback={<Spinner />}>
        <div className='App'>
          {this.state.isInitialized ? (
            <Router initialized={this.state.isInitialized} />
          ) : (
            <Spinner />
          )}
        </div>
      </Suspense>
    );
  }
}

export default App;
